export const ASSET_STATUSES = [
    { value: 'enabled', name: 'Enabled', label: 'Enabled' },
    { value: 'disabled', name: 'Disabled', label: 'Disabled' },
    { value: 'new', name: 'New', label: 'New' },
];